import { useTranslation as useI18nTranslation } from 'react-i18next';
import { TranslationKey, LanguageOption } from '../types/i18n';

export const useTranslation = () => {
  const { t: i18nT, i18n } = useI18nTranslation();

  // Helper function that takes English string as key and returns localized text
  const t = (englishKey: TranslationKey, options?: any): string => {
    const result = i18nT(englishKey, options);
    return typeof result === 'string' ? result : String(result);
  };

  // Function to change language
  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  // Get current language
  const currentLanguage = i18n.language;

  // Get available languages
  const availableLanguages = ['en', 'fr', 'it', 'es', 'de', 'nl', 'fil'];

  return {
    t,
    changeLanguage,
    currentLanguage,
    availableLanguages,
    i18n,
  };
};
